import routerServices from './experience.router.service';

const ExperienceRoot = () => import('@experience/views/root/ExperienceRoot.vue');
const ExperienceIframe = () => import('@experience/views/root/ExperienceIframe.vue');
const ExperienceList = () => import('@experience/views/list/ExperienceList.vue');
// const ExperienceListGuide = () => import('@experience/views/list/ExperienceListGuide.vue');
const ExperienceOnboarding = () => import('@experience/views/onboarding/ExperienceOnboarding.vue');
const ExperienceReport = () => import('@experience/views/report/ExperienceReport.vue');
const ExperienceReportOverview = () => import('@experience/views/report/ExperienceOverview.vue');
const ExperienceDetails = () => import('@experience/views/report/ExperienceDetails.vue');
const ExperienceReportAb = () => import('@experience/views/report/ExperienceAbtest.vue');
const ExperienceReportForm = () => import('@experience/views/report/ExperienceForm.vue');
const ExperienceSetting = () => import('@experience/views/setting/ExperienceSetting.vue');
const ExperienceEditor = () => import('@experience/views/editor/ExperienceEditor.vue');
const Integration = () => import('@master/views/integration/Integration.vue');
const IntegrationApp = () => import('@master/views/integration/app/IntegrationApp.vue');
const IntegrationAppDetail = () => import('@master/views/integration/app/IntegrationAppDetail.vue');
const IntegrationApi = () => import('@master/views/integration/api/IntegrationApi.vue');

export default [
    {
        name: 'ExperienceRoot',
        path: 'experience',
        component: ExperienceRoot,
        beforeEnter: routerServices.beforeEnterExperience,
        redirect: {
            name: 'ExperienceList'
        },
        children: [
            {
                path: 'v3/:path*',
                name: 'ExperienceV3',
                component: ExperienceIframe,
                beforeEnter: routerServices.beforeEnterExperienceV3
            },
            {
                path: 'list/:backType*',
                name: 'ExperienceList',
                component: ExperienceList,
                beforeEnter: routerServices.beforeEnterEngagement,
                meta: {
                    titleI18n: 'router_title.landing_page.page_management'
                }
            },
            {
                path: ':experienceId',
                name: 'ExperienceReport',
                component: ExperienceReport,
                redirect: { name: 'ExperienceDetails' },
                beforeEnter: routerServices.beforeEnterExperienceV4,
                children: [
                    {
                        name: 'ExperienceDetails',
                        path: 'details',
                        component: ExperienceDetails,
                        meta: {
                            hideReportHeaderShadow: true,
                            titleI18n: 'router_title.landing_page.page_report'
                        }
                    },
                    {
                        name: 'ExperienceReportOverview',
                        path: 'report',
                        component: ExperienceReportOverview,
                        meta: {
                            hideReportHeaderShadow: true,
                            titleI18n: 'router_title.landing_page.page_report'
                        }
                    },
                    {
                        name: 'ExperienceReportAb',
                        path: 'abTest',
                        component: ExperienceReportAb,
                        meta: {
                            hideReportHeaderShadow: true,
                            titleI18n: 'router_title.landing_page.page_report'
                        }
                    },
                    {
                        name: 'ExperienceReportForm',
                        path: 'form',
                        component: ExperienceReportForm,
                        meta: {
                            hideReportHeaderShadow: true,
                            titleI18n: 'router_title.landing_page.page_report'
                        }
                    },
                    {
                        name: 'ExperienceSetting',
                        path: 'setting',
                        component: ExperienceSetting,
                        meta: {
                            hideReportHeader: true,
                            titleI18n: 'router_title.landing_page.page_setting'
                        },
                        children: [
                            {
                                name: 'ExperienceEditor',
                                path: 'editor',
                                component: ExperienceEditor,
                                meta: {
                                    hideReportHeader: true,
                                    titleI18n: 'router_title.landing_page.page_setting'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: 'guide',
                name: 'ExperienceListGuide',
                component: ExperienceOnboarding,
                beforeEnter: routerServices.beforeEnterExperienceV4,
                meta: {
                    titleI18n: 'router_title.menu.engagement'
                }
            },
            {
                path: 'integration',
                name: 'Integration',
                component: Integration,
                beforeEnter: routerServices.beforeEnterIntegration,
                redirect: {
                    name: 'IntegrationApp'
                },
                children: [
                    {
                        path: 'app',
                        name: 'IntegrationApp',
                        component: IntegrationApp,
                        meta: {
                            hideSubHeader: true,
                            titleI18n: 'router_title.integration.app'
                        },
                        children: [
                            {
                                path: 'ga4',
                                name: 'IntegrationAppGA4',
                                component: IntegrationAppDetail,
                                meta: {
                                    pageBackgroundColor: '#fff',
                                    hideSubHeader: true,
                                    hideIntegrationHeader: true,
                                    titleI18n: 'router_title.integration.app_shopify',
                                    platform: 'GA4'
                                }
                            },
                            {
                                path: 'shopify',
                                name: 'IntegrationAppShopify',
                                component: IntegrationAppDetail,
                                meta: {
                                    pageBackgroundColor: '#fff',
                                    hideSubHeader: true,
                                    hideIntegrationHeader: true,
                                    titleI18n: 'router_title.integration.app_ga4',
                                    platform: 'SHOPIFY'
                                }
                            }
                        ]
                    },
                    {
                        path: 'api',
                        name: 'IntegrationApi',
                        component: IntegrationApi,
                        meta: {
                            hideSubHeader: true,
                            titleI18n: 'router_title.integration.api'
                        }
                    }
                ]
            }
        ]
    }
];
